import React, { useState, useEffect } from 'react'
import Information from '../../../../Shared/Card/Information';
import { GetAppInformationContent } from '../../../../Shared/InformationContent/PlsInformation';
import DocumentUpload from '../../../../Shared/Upload/DocumentUpload';
import { Card } from 'react-bootstrap';

function QuizzesPage(props) {
    //const attachmentTypes = [
    //    {
    //        "label": "Quiz - Laws and Rules", "value": 12
    //    },
    //    {
    //        "label": "Quiz - Ethics", "value": 13
    //    },
    //    {
    //        "label": "Quiz - Standards of Practice", "value": 14
    //    }
    //]
    return (
        <div>
            <Information content={GetAppInformationContent("quiz")} isQuiz={true} />
            <br />
            <Card>
                <Card.Body>
                    <DocumentUpload
                        isUserEditable={props.isUserEditable}
                        credentialTypeId={5}
                        sectionId={3}
                        attachmentSection={"Quiz"}
                        //appTypeId={}
                        //refreshData={ }
                        parentId={props.sectionId}
                        parentTypeId={3}
                        entityId={props.entityId}
                        fileUploadTitle={"Quiz File Upload"}
                    />
                </Card.Body>
            </Card>
        </div>
    )
}
export default QuizzesPage;